var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 d-flex page-with-footer flex-column justify-space-between",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-0 pb-2"},[_vm._t("content")],2)],1),_c('v-row',{staticClass:"flex-grow-0 ma-0"},[_c('v-col',{staticClass:"pa-0"},[_vm._t("footer",function(){return [_c('page-footer')]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }